import React from 'react'
import { makeStyles } from '@material-ui/core'
import PropTypes from 'prop-types'
import clsx from 'clsx'
import TypeMarker from '../../../shared/TypeMarker'
import { commonCardStyles } from '../commonStyles'
import EntryMenu from '../../EntryMenu'

const useStyles = makeStyles((theme) => ({
  container: {
    userSelect: 'none',
    opacity: ({ disabled }) => (disabled ? 0.5 : 1),
    position: 'relative',
    display: 'flex',
    flexFlow: 'row nowrap',
    gap: theme.layout.gap.g10,
    alignItems: 'center',
    justifyContent: 'flex-start',
    fontSize: '1rem',
    width: 'auto',
    minHeight: '40px',
    ...(commonCardStyles()),
    boxSizing: 'border-box',
    textAlign: 'center',
    transition: 'box-shadow .2s ease-in-out, outline .2s ease-in-out',
    outline: '2px solid transparent',
    cursor: ({ clickable }) => (clickable ? 'pointer' : 'none'),
    '&:hover': {
      outlineColor: ({ disabled }) =>
        disabled ? 'var(--color-surface-100)' : 'color-mix(in srgb, var(--color-primary-500) 50%, transparent)',
      cursor: ({ disabled }) => (disabled ? 'initial' : 'pointer')
    },
    '&:active': {
      backgroundColor: 'color-mix(in srgb, var(--color-primary-500) 15%, transparent)'
    },
    '&.__selected': {
      outlineColor: 'var(--color-primary-500)',
      boxShadow: theme.layout.shadow.deep
    },
    '& .__left': {
      display: 'flex',
      flexDirection: 'row',
      alignItems: 'center',
      justifyContent: 'center',
      paddingLeft: theme.layout.padding.p10
    },
    '& .__right': {
      flex: '1 0',
      overflow: 'hidden',
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'flex-start',
      justifyContent: 'center',
      paddingRight: theme.layout.padding.p10
    },
    '& .MuiIconButton-root': {
      paddingTop: 6,
      paddingBottom: 6,
      borderRadius: 'var(--border-radius-lg)'
    }
  },
  title: {
    width: '100%',
    fontSize: theme.typography.fontSizes.md,
    fontWeight: theme.typography.weights.light,
    textAlign: 'left',
    textOverflow: 'ellipsis',
    overflow: 'hidden',
    whiteSpace: 'nowrap'
  },
  target: {
    fontSize: '0.75rem',
    opacity: '0.5',
    bottom: '1rem'
  },
  icon: {
    width: '5.5rem',
    height: '5.5rem',
    fontSize: '2rem',
    color: 'var(--text-color-main)',
    backgroundColor: 'var(--color-surface-100)'
  }
}))

const HorizontalCompact = ({ entry, selected, disabled, onClick, allowEdit }) => {
  const classes = useStyles({ disabled, clickable: Boolean(onClick) })

  return (
    <div
      className={clsx(classes.container, { __selected: selected }, 'wj_entry')}
      data-year={entry.year}
      data-entry-id={entry.entryId}
      onClick={onClick}
    >
      <div className='__left'>
        <TypeMarker color={entry.entryType?.color} size={24} />
      </div>
      <div className='__right'>
        <div className={classes.title}>
          {entry.entryJson?.title || entry.entryText}
        </div>
      </div>
      {allowEdit ? (
        <div className={classes.menu}>
          <EntryMenu entry={entry} size='20px' />
        </div>
      ) : null}
    </div>
  )
}

HorizontalCompact.propTypes = {
  entry: PropTypes.object.isRequired,
  disabled: PropTypes.bool,
  selected: PropTypes.bool,
  onClick: PropTypes.func,
  allowEdit: PropTypes.bool
}

export default HorizontalCompact
